import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route: AnyRoute = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/app" })
  },
  component: () => null,
})
